export default "__VITE_ASSET__Bh0iiB3___"